var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,[React.createElement("path",{"opacity":"1","stroke":"#fff","strokeWidth":"4","strokeLinecap":"round","d":"M2 2.3254L37.0333 2.3254","key":0}),React.createElement("path",{"opacity":"1","stroke":"#fff","strokeWidth":"4","strokeLinecap":"round","d":"M2 14.1006L37.0333 14.1006","key":1}),React.createElement("path",{"opacity":"1","stroke":"#fff","strokeWidth":"4","strokeLinecap":"round","d":"M2 25.8757L37.0333 25.8757","key":2})]);
}

Menu.defaultProps = {"width":"40","height":"28","fill":"none"};

module.exports = Menu;

Menu.default = Menu;
